// #genai Phase 2 empty-state styles — pixel-matched to Figma:
//   Desktop empty 269:20209 ; Mobile empty 269:20315.
// Desktop: content sits on the gray page background (#F0F2F7) with NO white card. Title 16px
//   #1B202C, message 14px #61687D.
// Mobile: content sits on a white surface. Title 18px medium #0A0A0A, message 14px #737373.
// The "Add Payment Method" button + payment-type menu live in the shared AddPaymentMethodButton.
import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  // Fills the page content area and centers the empty block. Desktop shows the gray page
  // background through; mobile is a white surface (Figma 269:20315 "Application List").
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: '16px 24px',
    '@media (max-width: 639px)': {
      padding: '0px',
      backgroundColor: '#FFFFFF',
    },
  },

  // Centered column — gap 24 between header group and button, width 308 (desktop).
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    width: '308px',
    // #genai Mobile (Figma 269:20319): 342 content within 390 frame (24px gutters); button
    // spans the full content width.
    '@media (max-width: 639px)': {
      width: '100%',
      maxWidth: '390px',
      padding: '0 24px',
      boxSizing: 'border-box',
    },
  },

  // Title + message group — gap 8, centered.
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    textAlign: 'center',
  },

  // Desktop: 16px regular #1B202C (Figma 269:20216). Mobile: 18px medium #0A0A0A (Figma 269:20323).
  title: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#1B202C',
    width: '100%',
    '@media (max-width: 639px)': {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '28px',
      color: '#0A0A0A',
    },
  },

  // Desktop: 14px #61687D lh18 (Figma 269:20217). Mobile: 14px #737373 lh1.625 (Figma 269:20324).
  message: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#61687D',
    width: '100%',
    '@media (max-width: 639px)': {
      lineHeight: '1.625',
      color: '#737373',
    },
  },
}));
